"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeToISO = void 0;
const localeToISO = (locale) => {
    const [localeCode, alphabetOrCountryCode, countryCode] = locale.split('-');
    if (!localeCode)
        throw new Error('Not found locale code');
    const result = {
        localeCode: localeCode.toLocaleLowerCase(),
        alphabetCode: null,
        countryCode: null,
    };
    if (!alphabetOrCountryCode) {
        return result;
    }
    if (alphabetOrCountryCode && countryCode) {
        result.alphabetCode = formatAlphabetCode(alphabetOrCountryCode);
        result.countryCode = formatCountryCode(countryCode);
    }
    else if (alphabetOrCountryCode.length > 2) {
        result.alphabetCode = formatAlphabetCode(alphabetOrCountryCode);
    }
    else {
        result.countryCode = formatCountryCode(alphabetOrCountryCode);
    }
    return result;
};
exports.localeToISO = localeToISO;
const formatAlphabetCode = (input) => input.replace(/\w/, char => char.toUpperCase());
const formatCountryCode = (input) => input.toUpperCase();
